import { render, staticRenderFns } from "./ClientViewSidebarCreationSource.vue?vue&type=template&id=152c3e1a&scoped=true"
import script from "./ClientViewSidebarCreationSource.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarCreationSource.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarCreationSource.vue?vue&type=style&index=0&id=152c3e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c3e1a",
  null
  
)

export default component.exports